import axios from "axios";
import { uploadImage } from "./ApiEndPoint";

export const UploadImages = async (
  file: File,
  fileType: any,
  userId: any,
  roomId?: any,
  venueId?: any,
  onProgress?: any
) => {
  if (!file) {
    return null;
  }
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileType", fileType);
  formData.append("compressVideo", "true");

  if (userId) formData.append("userId", userId);
  if (roomId) formData.append("roomId", roomId);
  if (venueId) formData.append("venueId", venueId);

  try {
    const res = await axios.post(uploadImage, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent: any) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });

    return res.data;
  } catch (error) {
    console.error("Upload failed", error);
    alert("Upload failed, check console");
    return null;
  }
};
